import { LoginFormContainer } from "../../features/auth/components/LoginForm";

const Login = () => {
  return <LoginFormContainer />;
};

export default Login;
